import React, { forwardRef } from "react";
import FormField, {
  cx,
  getControlClassName,
  pickTouched,
} from "components/fields/FormField";

/**
 * Text input with label, hint and error.
 *
 * Props:
 * - id (auto when omitted), label, required=false, hint, error, touched: see FormField.
 * - type="text", placeholder, value, onChange, onBlur, name, disabled, … : forwarded to the <input>.
 * - state: "error" marks the input invalid without a message; other values are ignored.
 * - variant: only "auth" changes styling (label indent); other values are ignored.
 * - extra / className: wrapper classes.
 * - ref: forwarded to the <input>.
 */
const InputField = forwardRef(function InputField(props, ref) {
  const {
    id,
    label,
    required = false,
    hint,
    error,
    touched,
    state,
    variant,
    extra = "",
    className = "",
    type = "text",
    ...rest
  } = props;

  return (
    <FormField
      id={id}
      label={label}
      required={required}
      hint={hint}
      error={error}
      {...pickTouched(props)}
      invalid={state === "error"}
      className={cx(extra, className)}
      labelClassName={variant === "auth" ? "ml-1.5" : ""}
    >
      {(controlProps) => (
        <input
          ref={ref}
          type={type}
          required={required}
          {...rest}
          {...controlProps}
          className={getControlClassName({
            invalid: controlProps["aria-invalid"],
          })}
        />
      )}
    </FormField>
  );
});

export default InputField;
